<div class="card">
    <div class="card-body">
        <form [formGroup]="editTenantForm" novalidate>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field style="width: 0; height: 0;">
                        <input matInput hidden  formControlName="id">
                    </mat-form-field>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['INPUTTENANTNAME'] | translate}}" formControlName="name" readonly>
                    </mat-form-field>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Scope" formControlName="scopeName" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Frontend URL" formControlName="frontendUrl" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="System Typ" formControlName="systemType" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="systemType === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Mandant" formControlName="wpTenant" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="systemType === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Api Key Inbound" formControlName="wpApiKeyInbound" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="systemType === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Api User" formControlName="wpApiUser" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" *ngIf="systemType === 'WINPLAN'">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Winplan Api Key" formControlName="wpApiKey" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="clearfix"></div>
        </form>
    </div>
</div> 